module.exports = __webpack_public_path__ + "static/media/DSC_2269.45320ebd.jpg";